import { useCallback, useEffect, useRef, useState } from "react";

/**
 * When should the Estimator refetch prices after Pricing Admin changes?
 *
 * Pricing Admin calls onPricingSaved after every successful save. While the
 * user is still on Pricing Admin that is only noted; leaving the page bumps
 * refreshTick once. A save that lands after the user has left (the field
 * that had focus saves on the way out) bumps it straight away. No saves →
 * no refetch.
 */
export function usePricingRefreshTrigger(
  activeNav: string,
  adminNav = "pricingAdmin"
) {
  const activeNavRef = useRef(activeNav);
  const savedWhileOnAdminRef = useRef(false);
  const [refreshTick, setRefreshTick] = useState(0);

  const onPricingSaved = useCallback(() => {
    if (activeNavRef.current === adminNav) {
      savedWhileOnAdminRef.current = true;
    } else {
      setRefreshTick((t) => t + 1);
    }
  }, [adminNav]);

  useEffect(() => {
    const prev = activeNavRef.current;
    activeNavRef.current = activeNav;
    if (prev === adminNav && activeNav !== adminNav && savedWhileOnAdminRef.current) {
      savedWhileOnAdminRef.current = false;
      setRefreshTick((t) => t + 1);
    }
  }, [activeNav, adminNav]);

  return { onPricingSaved, refreshTick };
}
